import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

interface Props {
  split: boolean;
  opacity: number;
}

const DetailAddonChannelsContainer = styled.div<Props>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  height: ${(props) => Screen.widthRatio * (props.split ? 260 : 140)}px;
  padding: ${Screen.widthRatio * 20}px ${Screen.widthRatio * 40}px;
  opacity: ${(props) => props.opacity};
  top: ${(props) => Screen.widthRatio * (props.split ? 260 : 330)}px;
  width: 100%;
`;

export default withAnimation(DetailAddonChannelsContainer);
